/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import Migration from "../../../components/Administrations/Migration/Filters/Migration";
import { DIALOGOPENFOR } from "../../../globals/globals";
import { useSelector } from "react-redux";
import { basicDialogSelector } from "../../../store/helpers/helperSelectors";
import NewMigration from "../../../components/Administrations/Migration/NewMigration";
import { useMigrationData } from "./hooks";
import SiteMigration from "../../../components/Administrations/Migration/SiteMigration";
import MigrateSiteToRegion from "../../../components/Administrations/Migration/MigrateSiteToRegion";

const DeviceMigration: React.FC = () => {
  const basicDialodOpenFor = useSelector(basicDialogSelector);
  const {
    data,
    isLoading,
    isConnected,
    loginData,
    setLoginData,
    errMsg,
    setErrMsg,
    submitConnectHandler,
    loginStatus,
    siteMigrationData,
    onBlurHandler,
    selectedGeoRegion,
    siteGroupId,
    setSiteGroupId,
    setSelectedRow,
    startMigrationHandler,
    setSiteMigrationData,
    setSortOrderToMigration,
  } = useMigrationData();

  const rowsData = data?.data || [];
  const noOfRows = data?.totalItems || 0;
  return (
    <>
      {basicDialodOpenFor === DIALOGOPENFOR.MIGRATESITETOREGION && (
        <MigrateSiteToRegion
          siteGroupId={siteGroupId}
          setSiteGroupId={setSiteGroupId}
          currentRegion={selectedGeoRegion}
          startMigrationHandler={startMigrationHandler}
        />
      )}
      {basicDialodOpenFor === DIALOGOPENFOR.MIGRATION && (
        <NewMigration
          loginData={loginData}
          setLoginData={setLoginData}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
          submitConnectHandler={submitConnectHandler}
          loginStatus={loginStatus}
          onBlurHandler={onBlurHandler}
        />
      )}
      <div className="flex flex-col gap-14 p-2">
        <div className="pt-2 pl-2">
          {!isConnected ? (
            <div className="w-full">
              <Migration migrationData={rowsData} isLoading={isLoading} noOfRows={noOfRows} setSortOrderToMigration={setSortOrderToMigration} />
            </div>
          ) : (
            <div className="w-full">
              <SiteMigration
                siteMigrationData={siteMigrationData}
                setSiteMigrationData={setSiteMigrationData}
                loginStatus={loginStatus}
                setSelectedRow={setSelectedRow}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DeviceMigration;
